import React from 'react';
import { themeContext } from "../../containers/ThemeProvider";
import { Button } from 'semantic-ui-react';

export default class ContractTermSection extends React.Component {
  static contextType = themeContext;

  constructor(props) {
    super(props);
    const shouldHideOneMonthOption = props.shouldHideOneMonthOption || false;
    
    this.state = {
      selectedContractTerm: shouldHideOneMonthOption ? '12' : '1',
      validationMessage: '',
      contractOptions: [
        { value: '1', label: '1 Month' },
        { value: '12', label: '12 Months' },
        { value: '24', label: '24 Months' },
        { value: '36', label: '36 Months' },
      ] 
    };
  }

  componentDidMount() {
    // Notify parent of initial selection
    if (this.props.onContractTermChange) {
      this.props.onContractTermChange(this.state.selectedContractTerm);
    }
  }

  componentDidUpdate(prevProps) {
    // Handle prop changes
    if (prevProps.shouldHideOneMonthOption !== this.props.shouldHideOneMonthOption) {
      const newTerm = this.props.shouldHideOneMonthOption ? '12' : '1';
      this.setState({ selectedContractTerm: newTerm });
      if (this.props.onContractTermChange) {
        this.props.onContractTermChange(newTerm);
      }
    }
  }

  onContractTermSelect = (value) => {
    this.setState({ selectedContractTerm: value });
   
    if (this.props.onContractTermChange) {
      this.props.onContractTermChange(value);
    }
  };

  getFilteredOptions() {
    return this.props.shouldHideOneMonthOption
      ? this.state.contractOptions.filter(option => option.value !== '1')
      : this.state.contractOptions;
  }

  renderOptionContent() {
    const { selectedContractTerm } = this.state;
    const { assets } = this.context;
    const filteredOptions = this.getFilteredOptions();

    return (
      <div className="row" style={{ display: 'flex', flexDirection: 'row', marginTop: '15px', marginBottom: '15px', width: 'auto', justifyContent: 'center', marginLeft: '0.5px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-start" style={{ gap: '10px', marginLeft: '20px' }}>
            {filteredOptions.map(option => (
              <Button
                key={option.value}
                name="contractTerm"
                onClick={() => this.onContractTermSelect(option.value)}
                className={` ${selectedContractTerm === option.value ? 'selectedOption' : ''}`}
                color={selectedContractTerm === option.value ? assets?.headerColour : ''}
                style={{
                  minWidth: '150px',
                  marginRight: '7px',
                  fontWeight: 'bold',
                  boxShadow: selectedContractTerm === option.value ? `0 4px 8px rgba(0, 0, 0, 0.2)` : '',
                  backgroundColor: assets?.backgroundColor
                }}
                type="button"
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderOptionContent();
  }
}